import * as React from 'react';
import {FunctionComponent, useMemo} from 'react';
import {observer} from 'mobx-react-lite';
import {PresenterProps, withPresenter} from '../../../../../Support/with_presenter';
import {RsvpResponseButtonsPresenter} from './RsvpResponseButtonsPresenter';
import {CalendarEvent, RsvpResponse} from '../../../../../Models/CalendarEvent';

interface OwnProps {
    userId: number;
    calendarEvent: CalendarEvent;
}

const RsvpResponseButtonsComponent: FunctionComponent<OwnProps & PresenterProps<RsvpResponseButtonsPresenter>> =
    observer(({presenter}) => {
        const instanceId = useMemo(() => {
            return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
        }, []);

        return (
            <form>
                <div className="btn-group d-flex" role="group">
                    <input
                        type="radio"
                        className="btn-check"
                        name="rsvp-response"
                        id={instanceId + 'rsvp-yes'}
                        autoComplete="off"
                        value={RsvpResponse.Yes}
                        checked={presenter.hasRsvpResponse(RsvpResponse.Yes)}
                        onChange={() => presenter.onRsvpResponseChange(RsvpResponse.Yes)}
                    />
                    <label className="btn btn-outline-primary w-100" htmlFor={instanceId + 'rsvp-yes'}>
                        Yes
                    </label>
                    <input
                        type="radio"
                        className="btn-check"
                        name="rsvp-response"
                        id={instanceId + 'rsvp-maybe'}
                        autoComplete="off"
                        value={RsvpResponse.Maybe}
                        checked={presenter.hasRsvpResponse(RsvpResponse.Maybe)}
                        onChange={() => presenter.onRsvpResponseChange(RsvpResponse.Maybe)}
                    />
                    <label className="btn btn-outline-primary w-100" htmlFor={instanceId + 'rsvp-maybe'}>
                        Maybe
                    </label>
                    <input
                        type="radio"
                        className="btn-check"
                        name="rsvp-response"
                        id={instanceId + 'rsvp-no'}
                        autoComplete="off"
                        value={RsvpResponse.No}
                        checked={presenter.hasRsvpResponse(RsvpResponse.No)}
                        onChange={() => presenter.onRsvpResponseChange(RsvpResponse.No)}
                    />
                    <label className="btn btn-outline-primary w-100" htmlFor={instanceId + 'rsvp-no'}>
                        No
                    </label>
                </div>
            </form>
        );
    });

export const RsvpResponseButtons = withPresenter<RsvpResponseButtonsPresenter, OwnProps>(
    (props, component) => new RsvpResponseButtonsPresenter(props.userId, props.calendarEvent, component.rsvp),
    RsvpResponseButtonsComponent,
);
